// services/chatbotService.js
import { getHandleResponse } from "helpers/getHandleResponse";
import { getAuthHeader } from "helpers/getAuthHeader";

const API_BASE_URL = process.env.REACT_APP_URL;

const makeRequest = async (endpoint, method, data = null) => {
    const requestOptions = {
        method,
        headers: getAuthHeader(),
    };

    if (data) {
        requestOptions.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        const result = await getHandleResponse(response);
        return { error: false, data: result };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const chatbotService = {
    // Enviar mensaje al chatbot
    sendMessage: (data) => makeRequest("/api/chatbot/message", "POST", data),

    // Obtener conversación activa
    getActiveConversation: () => makeRequest("/api/chatbot/active", "GET"),

    // Obtener conversación específica
    getConversation: (id) => makeRequest(`/api/chatbot/conversation/${id}`, "GET"),

    // Obtener historial de conversaciones
    getHistory: (limit = 10) => makeRequest(`/api/chatbot/history?limit=${limit}`, "GET"),

    // Iniciar nueva conversación
    newConversation: () => makeRequest("/api/chatbot/new", "POST"),

    // Cerrar conversación
    closeConversation: (id) => makeRequest(`/api/chatbot/close/${id}`, "POST"),

    // Obtener respuestas rápidas
    getQuickResponses: () => makeRequest("/api/chatbot/quick-responses", "GET"),
};

export default chatbotService;
